import { useEffect, useState } from 'react';

const KEY = 'stark-archive-reduced-motion';

export function useMotionPreference() {
  const [reduced, setReduced] = useState(() => {
    const saved = localStorage.getItem(KEY);
    return saved === null ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : saved === 'true';
  });

  useEffect(() => {
    document.documentElement.dataset.motion = reduced ? 'reduced' : 'full';
    localStorage.setItem(KEY, String(reduced));
  }, [reduced]);

  return { reduced, setReduced };
}
